// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Element from 'element-ui'
import "element-ui/lib/theme-chalk/index.css"
import XLSX from 'xlsx'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import echarts from 'echarts'
import store from './store/index.js'
import md5 from 'js-md5'

Vue.prototype.$echarts = echarts
Vue.prototype.$md5 = md5




Vue.use(ElementUI, { locale })
Vue.use(Element);

Vue.prototype.$axios = axios

axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('Authorization')){
      config.headers.Authorization = localStorage.getItem('Authorization')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

Vue.config.productionTip = false

// axios.defaults.baseURL = 'http://127.0.0.1:60004/'
axios.defaults.baseURL = 'http://confirm-web-api.vobile.net/'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store:store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js